import { Component, Input } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { InputsValidators } from 'src/app/utils/services/inputs-validators';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent {

  @Input() title: string;
  @Input() type: string;
  @Input() function: string;
  @Input() color: string;

  constructor(private translate: TranslateService, private alertController: AlertController) { }

  async alertFreeGuestLogIn() {
    const alert = await this.alertController.create({
      cssClass: 'alert-generic',
      message: await this.translate.get('are_you_sure_free_guest').toPromise(),
      mode: 'md',
      buttons: [
        {
          text: 'Ok',
          role: 'valid',
          cssClass: 'secondary',
        },
        {
          text: await this.translate.get('cancel').toPromise(),
          role: 'cancel',
          cssClass: 'light',
        }
      ]
    });

    return alert;
  }

  async alertFreeGuest() {
    const alert = await this.alertController.create({
      cssClass: 'alert-generic',
      message: await this.translate.get('not_available_for_guest').toPromise(),
      mode: 'md',
      buttons: [
        {
          text: 'Ok',
          role: 'valid',
          cssClass: 'secondary',
        },
      ]
    });

    await alert.present();
  }

  async alertRecoverPassword() {
    const alert = await this.alertController.create({
      cssClass: 'alert-generic',
      header: await this.translate.get('forgot_password').toPromise(),
      inputs: [
        {
          name: 'email',
          type: 'text',
          placeholder: await this.translate.get('placeholder_email').toPromise()
        },
      ],
      buttons: [
        {
          text: await this.translate.get('cancel').toPromise(),
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: await this.translate.get('recover').toPromise(),
          cssClass: 'secondary',
          handler: async (e) => {
            const email = e.email;

            if (email) {
              // alert.message = await this.translate.get('required').toPromise();
              return false;
            }

            if (!InputsValidators.validEmail(email)) {
              // alert.message = await this.translate.get('bad_format').toPromise();
              return false;
            }
          }
        }
      ]
    });

    await alert.present();
  }


  launchAlert() {
    if (this.function === 'alertRecoverPassword') {
      this.alertRecoverPassword();
    }
  }
}
